export default __webpack_public_path__ + "static/icon-map-pin-branch-cardlock-2e2b409aa012707640905629e7cf71d1.png";